import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { LatLong } from '../../../models/Geometries';
import { Layer, Source } from 'react-map-gl';
import { useMemo } from 'react';
import { generateRectangle } from '../../../utils/GeometryUtils';
import { Feature } from '../../../models/Geoserver';

interface Props {
  mousePosition: LatLong | undefined;
}

function MapMultipleSelection({ mousePosition }: Props) {
  const dispatch = useAppDispatch();
  const firstPoint = useAppSelector(state => state.mapLayers.firstPoint);
  const secondPoint = useAppSelector(state => state.mapLayers.secondPoint);
  const addingMultipleFeatures = useAppSelector(state => state.mapLayers.addingMultipleFeatures);

  const rectangle = useMemo(() => {
    if (addingMultipleFeatures && firstPoint && mousePosition) {
      return generateRectangle(mousePosition, firstPoint);
    } else if (firstPoint && secondPoint) {
      return generateRectangle(firstPoint, secondPoint);
    }
  }, [firstPoint, secondPoint, mousePosition, addingMultipleFeatures]);

  if (!rectangle || secondPoint) {
    return null;
  }

  return (
    <div>
      <Source id={'MULTIPLE_SELECTION_SOURCE'}
              type='geojson' data={{
        type: 'Feature',
        geometry: rectangle as any,
        properties: {},
      }}>
        <Layer id={'MULTIPLE_SELECTION_SOURCE_polygon'} type={'line'} paint={{
          'line-color': '#0078A0',
          'line-width': 2,
          'line-dasharray': [0.5, 0.5],
        }} beforeId={'order-polygon'}
        />
        <Layer id={'MULTIPLE_SELECTION_SOURCE_polygon_fill'} type={'fill'} paint={{
          'fill-color': '#0078A0',
          'fill-opacity': 0.2,
        }} beforeId={'order-polygon'}
        />
      </Source>
    </div>
  );
}

export default MapMultipleSelection;
